<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="20">
            <a type="" @click="load">刷新</a>
            <cite>|</cite>
            <a type="primary" @click="m2.modal=true">导入</a>
            <cite>|</cite>
            <a type="success" @click="start('postfix')">配置Pistfix</a>
            <cite>|</cite>
<!--            <a type="success" @click="start('oem')">配置OEM平台</a>-->
<!--            <cite>|</cite>-->
<!--            <a type="success" @click="start('apisend')">配置API发送</a>-->
<!--            <cite>|</cite>-->
<!--            <a type="success" @click="start('mxsend')">配置MX发送</a>-->
<!--            <cite>|</cite>-->
<!--            <a type="success" style="color: #8c939d" @click="start('mautic')">配置Mautic</a>-->
<!--            <cite>|</cite>-->
            <a type="error" style="color: red" @click="removeall()">清空数据</a>
            <cite>|</cite>
            <a type="info" @click="exportExcel">数据导出</a>
            <cite>|</cite>
            <a type="info" @click="huifu" :disabled="ids.length==0">恢复待处理状态</a>
            <cite>|</cite>

            <Select v-model="serch.state" style="width: 100px;" @on-change="reload" size="small">
              <Option value="">全部状态</Option>
              <Option value="成功">成功</Option>
              <Option value="失败">失败</Option>
            </Select>
            <!--<Button type="primary" @click="modal1=true">增加</Button>-->
          </Col>
          <Col span="4">
            <Input size="small" search enter-button placeholder="输入ip、域名、状态搜索" v-model="serch.key"  @on-search="reload"/>
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :border="1" :data="list" @selection-change="changeFun1" size="small" style="width: 100%" >
        <el-table-column type="selection" fixed="left"></el-table-column>
        <el-table-column prop="id" label="编号" width="60"  :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="type" label="配置类型" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            <Tag color="success" v-if="scope.row.type==='apisend'">API发送</Tag>
            <Tag v-else>{{scope.row.type}}</Tag>
          </template>
        </el-table-column>
        <el-table-column prop="ip" label="服务器IP" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            <a  v-if="scope.row.type==='apisend'" target="_blank" :href="'http://'+scope.row.ip+':8888'">{{scope.row.ip}}</a>
            <span v-else>{{scope.row.ip}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="password" label="服务器密码" :show-tooltip-when-overflow="true"></el-table-column>
        <!--<el-table-column prop="jiuxuState" label="就绪状态" :show-tooltip-when-overflow="true"></el-table-column>-->
        <!--<el-table-column prop="jiexiState" label="域名解析状态" :show-tooltip-when-overflow="true"></el-table-column>-->
        <!--<el-table-column prop="postfixState" label="postfix搭建状态" :show-tooltip-when-overflow="true"></el-table-column>-->
        <!--<el-table-column prop="checkSmtp" label="smtp检查状态" :show-tooltip-when-overflow="true"></el-table-column>-->
        <el-table-column prop="ename" label="英文名" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="domain" label="域名" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="outboxPassword" label="发件箱密码" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="state" label="处理状态" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            <span v-if="scope.row.state.indexOf('成功')!=-1" style="color: #19be6b">{{scope.row.state}}</span>
            <span v-else-if="scope.row.state.indexOf('正在')!=-1" style="color: #ff9900">{{scope.row.state}}</span>
            <span v-else-if="scope.row.state.indexOf('失败')!=-1" style="color: #ed4014">{{scope.row.state}}</span>
            <span v-else>{{scope.row.state}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="msg" label="错误信息" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="succTime" label="完成时间" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="ctime" label="创建时间" :show-tooltip-when-overflow="true"></el-table-column>

        <el-table-column prop="msg" label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <a @click="edit(scope.row.id)">编辑</a>
            <cite>|</cite>
            <a @click="remove(scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <br/>


    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save"
      @on-cancel="cancel">
      <Form :label-width="80">

        <FormItem label="服务器IP">
          <Input v-model="detail.ip"/>
        </FormItem>
        <FormItem label="服务器密码">
          <Input v-model="detail.password"/>
        </FormItem>
        <FormItem label="域名">
          <Input v-model="detail.domain"/>
        </FormItem>
        <FormItem label="英文名">
          <Input v-model="detail.ename"/>
        </FormItem>
        <FormItem label="返回信息">
          <Input v-model="detail.msg"/>
        </FormItem>
      </Form>
    </Modal>


    <Modal
      v-model="m2.modal"
      title="导入"
      width="800"
      :mask-closable="false"
      @on-ok="save2">

      <Row :gutter="16">
        <Col :span="12">
          <Input type="textarea" @on-change="changeInput" v-model="m2.value" :autosize="{minRows: 20}" placeholder="直接从excel中复制，格式：IP  服务器密码   域名"/>

        </Col>
        <Col :span="12">
          <b>核对表头内容是否匹配，数量是否正确，数量：{{m2.list.length}}</b>
          <el-table :data="m2.list" size="small" style="width: 100%" >
            <el-table-column prop="ip" label="服务器IP" :show-tooltip-when-overflow="true"></el-table-column>
            <el-table-column prop="password" label="服务器密码" :show-tooltip-when-overflow="true"></el-table-column>
            <el-table-column prop="domain" label="域名" :show-tooltip-when-overflow="true"></el-table-column>
          </el-table>
        </Col>
      </Row>


    </Modal>

  </div>
</template>

<script>
  export default {
    data(){
      return{
        baseUrl:'/api/client/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:'',
          state:'',
        },
        m2:{
          value:'',
          modal:false,
          list:[],
        },
        loading:false,
        ids:[],
      }
    },
    methods:{
      changeFun1(val) { //节点选择改变
        this.ids = [];
        for(let i=0;i<val.length;i++){
          this.ids.push(val[i].id);
        }
      },
      reload(){
        this.page = 1;
        this.load();
      },
      exportExcel(){
        window.location = '/api/export/outexcel?id=1';
      },
      changeInput(){
        this.m2.list = [];
        let value = this.m2.value.split(/\n/);
        for(let i = 0;i<value.length;i++){
          let arr = value[i].split(/\t/);
          let obj = {ip:arr[0],password:arr[1],domain:arr[2]};
          if(obj.ip){
            this.m2.list.push(obj);
          }
        }
        console.log(value);
      },
      save2(){
        if(this.m2.list.length==0){
          this.$Message.error('系统没理解什么意思');
        }
        let that = this;
        this.$axios({url:this.baseUrl+'save2',method:'post',data:this.m2.list}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.ip0t.domain0t.state@like@'+this.serch.key);
        }
        if(this.serch.state){
          params.push('t.state@like@'+this.serch.state);
        }
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },

      huifu(){
        this.$Modal.confirm({
          title: '系统提示',
          content: "将选中的"+this.ids.length+"条数据恢复成待处理状态",
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'huifu?ids='+this.ids).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },

      start(type){
        this.$Modal.confirm({
          title: '系统提示',
          content: "确定要开始配置"+type+"吗",
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'start?type='+type).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },

      removeall(){
        this.$Modal.confirm({
          title: '系统提示',
          content: "<font color='red'>确定要清空所有数据吗，此操作不可恢复</font>",
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'removeall').then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.load();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Client.vue